import { IDisplayPreference } from './definitions';

const arabic = new Intl.NumberFormat('ar-AE');
const persian = new Intl.NumberFormat('fa-IR');

export const PersianPreference: IDisplayPreference = {
	hour: (x: any) => persian.format(x),
	minute: (x: any) => {
		let exp = persian.format(x);
		if (exp.length === 1) {
			exp = persian.format(0) + exp;
		}
		return exp;
	},
	separator: ':',
	period: (x: any) => x === 'AM' ? 'صبح' : 'عصر',
	clockHour: (x: any) => persian.format(x),
	clockMinute: (x: any) => persian.format(x),
	labels: {
		ok: 'تایید',
		cancel: 'لغو'
	}
};

export const ArabicPreference: IDisplayPreference = {
	hour: (x: any) => arabic.format(x),
	minute: (x: any) => {
		let exp = arabic.format(x);
		if (exp.length === 1) {
			exp = arabic.format(0) + exp;
		}
		return exp;
	},
	separator: ':',
	period: (x: any) => x === 'AM' ? 'صباحا' : 'مساء',
	clockHour: (x: any) => arabic.format(x),
	clockMinute: (x: any) => arabic.format(x),
	labels: {
		ok: 'حسنا',
		cancel: 'إلغاء'
	}
};

export const ChinesePreference: IDisplayPreference = {
	hour: (x: any) => x,
	minute: (x: any) => {
		let exp = x;
		if (exp.length === 1) {
			exp = '۰' + exp;
		}
		return exp;
	},
	separator: ':',
	period: (x: any) => x === 'AM' ? '上午' : '下午',
	clockHour: (x: any) => x,
	clockMinute: (x: any) => x,
	labels: {
		ok: '确定',
		cancel: '取消'
	}
};

export const Preference = (locale: string): IDisplayPreference | null => {
	switch (locale) {
		case 'fa':
			return PersianPreference;
		case 'ar':
			return ArabicPreference;
		case 'zh':
			return ChinesePreference;
		default:
			return null;
	}
};
